import { render, staticRenderFns } from "./DoctorRegister.vue?vue&type=template&id=43cbd8dc"
import script from "./DoctorRegister.vue?vue&type=script&lang=js"
export * from "./DoctorRegister.vue?vue&type=script&lang=js"
import style0 from "./DoctorRegister.vue?vue&type=style&index=0&id=43cbd8dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports